enum DealSavingsType {
  SPECIAL_RATES = "specialRates",
  CURRENCY = "currency",
  PERCENTAGE = "percentage",
  FREE = "free"
}

export default DealSavingsType
